module.exports = __webpack_public_path__ + "static/media/gift06_zhCht.0a7b7f6f.png";